import { put, takeLatest, call } from 'redux-saga/effects';

import * as actions from './actions';
import quoteViewsService from './service';

const { types } = actions;

function* watchFetchQuoteViews({ payload }) {
  const { quoteId } = payload;
  try {
    const response = yield call(quoteViewsService.get, quoteId);
    yield put(actions.fetchQuoteViews.success(response));
  } catch (error) {
    yield put(actions.fetchQuoteViews.error(error));
  }
}

export default function* root() {
  yield takeLatest(types.FETCH_QUOTE_VIEWS_REQUEST, watchFetchQuoteViews);
}
